import { render, staticRenderFns } from "./MenuContainer.vue?vue&type=template&id=13814b2a&scoped=true&"
import script from "./MenuContainer.vue?vue&type=script&lang=js&"
export * from "./MenuContainer.vue?vue&type=script&lang=js&"
import style0 from "./MenuContainer.vue?vue&type=style&index=0&id=13814b2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13814b2a",
  null
  
)

export default component.exports